import s from './style.module.scss';
import GrtImage from '@/components/GrtImage';
import { CloseOutline } from 'antd-mobile-icons';
const AllCourseList = (props) => {
    const { data = [], clickLearn, viewDetail, onClose } = props;
    return (
        <div className={s['all-box-wrap']}>
            <div className={s['all-title']}>
                <div className={s['left']}>课程推荐</div>
                <span onClick={onClose}>
                    <CloseOutline />
                </span>
            </div>
            <div className={s['all-list-wrap']}>
                {data.map((ele, index) => {
                    return (
                        <div key={index} className={s['list-item']}>
                            <GrtImage src={ele?.image_url}></GrtImage>
                            <div className={s['info-wrap']}>
                                <div className={s['course-title']}>{ele.title}</div>
                                <div className={s['list-action']}>
                                    <span
                                        className={s['action-button']}
                                        onClick={() => {
                                            viewDetail(ele, data.length);
                                        }}
                                    >
                                        查看详情
                                    </span>
                                    <span
                                        data-type={'primary'}
                                        onClick={() => {
                                            clickLearn(ele.id);
                                        }}
                                        className={s['action-button']}
                                    >
                                        立即学习
                                    </span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AllCourseList;
